import React, { useContext, useState } from "react";
import styles from "../Profile/Profile.module.css";
import axios from "axios";
import deleteOpen from "../../assests/popup/deleteOpen.svg";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";

function UploadSucessDelete({
  setShowDelete,
  singleFileDetails,
  token,
  setUploadSucccess,
  handleBackClick,
}) {
  const campaignId = singleFileDetails?.campaignId;
  const contestId = singleFileDetails?.contestId;
  const videoId = singleFileDetails?.videoId;
  const orgId = singleFileDetails?.orgId;
  const [deleteNavigation, setDeleteNavigation] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      let cancel;
      let config4 = {
        method: "PATCH",
        url: `${process.env.REACT_APP_PROFILE_DELETE_ENTRY}/${orgId}/${campaignId}/${contestId}/${videoId}
          `,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        cancelToken: new axios.CancelToken((c) => (cancel = c)),
      };
      const response4 = await axios(config4);
      if (response4.status === 200) {
        handleBackClick();
        setUploadSucccess(false);
        setShowDelete(false);
        setDeleteLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      handleBackClick();
      setUploadSucccess(false);
      setShowDelete(false);
      setDeleteLoading(false);
    }
    if (deleteNavigation) {
      setUploadSucccess(false);
      setShowDelete(false);
    }
  };
  return (
    <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center">
      <div className={styles.deteleme}>
        <img src={deleteOpen} alt="" className="w-[56px] h-[56px] mb-[24px]" />
        <p className="text-regular-medium px-[20px] mb-[16px]">
          Are you sure want to delete your participation
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px]">
          You can’t undo this action.
        </p>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%]">
          <button
            className={styles.Deeleeete}
            onClick={() => handleDelete()}
            disabled={deleteLoading}
          >
            <p className="text-regular-medium">Delete</p>
          </button>
          <button
            className={styles.cancelDelete}
            onClick={() => setShowDelete(false)}
            disabled={deleteLoading}
          >
            <p className="text-regular-medium">Cancel</p>
          </button>
        </div>
        {deleteLoading && <LoadingFromCenter />}
      </div>
    </div>
  );
}

export default UploadSucessDelete;
